import {
  ApiGraphqlTypes as AGT,
  ChatMessage,
  addQuestionData,
  nzApiClient,
} from '@nizza/core';
import baseLogger from '~logger';
import { ChatMessageRepository } from '../domain/repositories/chatMessageRepository';

const logger = baseLogger.child('GraphqlChatMessageRepository');

export class GraphqlChatMessageRepository implements ChatMessageRepository {
  async deleteMessage(message: ChatMessage): Promise<void> {
    const { deleteChatMessage } = await nzApiClient.graphql(
      AGT.DeleteChatMessageDocument,
      {
        data: {
          account: message.account,
          idEvent: message.idEvent,
          sendDate: message.sendDate ?? '',
          id: message.id,
          username: message.username,
        },
      },
      {
        secure: true,
        account: message.account,
      },
    );

    this.handleGqlErr(deleteChatMessage as AGT.DeleteChatMessageResult);
  }

  async getAllMessages(
    eventId: string,
    account: string,
  ): Promise<ChatMessage[]> {
    const { getAllChatMessages } = await nzApiClient.graphql(
      AGT.GetAllChatMessagesDocument,
      {
        data: {
          account: account,
          idEvent: eventId,
        },
      },
    );

    this.handleGqlErr(getAllChatMessages as AGT.GetAllChatMessagesResult);

    const data = (getAllChatMessages as AGT.ChatMessageArray).data;
    return this.mapGqlMsgs(data);
  }

  async getAllAdminMessages(
    eventId: string,
    account: string,
  ): Promise<ChatMessage[]> {
    const { getAllAdminChatMessages } = await nzApiClient.graphql(
      AGT.GetAllAdminChatMessagesDocument,
      {
        data: {
          account: account,
          idEvent: eventId,
        },
      },
      {
        secure: true,
        account: account,
      },
    );

    this.handleGqlErr(
      getAllAdminChatMessages as AGT.GetAllAdminChatMessagesResult,
    );

    const data = (getAllAdminChatMessages as AGT.AdminChatMessageArray).data;
    return this.mapGqlMsgs(data);
  }

  private mapGqlMsgs(
    rawMsgs: (AGT.ChatMessage | AGT.AdminChatMessage)[] | null | undefined,
  ): ChatMessage[] {
    if (!rawMsgs) return [];

    return rawMsgs.map(rawMsg => {
      const msg: ChatMessage = {
        account: rawMsg.account,
        data: rawMsg.data.replace('replace_gif', rawMsg.urlGif ?? ''),
        id: rawMsg.id,
        idEvent: rawMsg.idEvent,
        sendDate: rawMsg.sendDate,
        type: rawMsg.type,
        username: rawMsg.username,
        isAdmin: rawMsg.isAdmin,
        second: rawMsg.second,
        ...((rawMsg as any).email && { email: (rawMsg as any).email }),
      };

      return addQuestionData(msg);
    });
  }

  private handleGqlErr(res: any) {
    if (res.__typename === 'ErrorGeneral') {
      logger.error(res.message);
      throw new Error(res.message);
    }
  }
}
